<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-4">
        <a
          v-if="pacienteSelected !== null"
          href="javascript:void(0)"
          class="btn btn-custom btn-block"
          :class="disableButtonAddServicio ? 'badge-secondary disabled-plomo' : 'badge-secondary'"
          @click="openModalServicios"
          :disabled="disableButtonAddServicio"
        >
          <b style="color: white;">Agregar Servicio</b>
        </a>
      </div>
      <div class="col-12 col-md-3 pl-0">
         <a
          v-if="pacienteSelected !== null && hasEnabledLaboratory"
            href="javascript:void(0)"
            class=" btn btn-custom btn-block"
            :class="cierreConfirmado? 'badge-light text-light':'badge-secondary'"
            @click="openModalLaboratorio"
            :disabled="cierreConfirmado"
          >
            <b>Laboratorio</b>
          </a>
      </div>
    </div>
    <b-modal id="modal-servicios"
     v-model="modalShow"
     size="lg"
     @ok="agregarServicio"
     @hidden="resetearModal">
     <template #modal-title>
      <div class="w-100 d-flex">
        <strong><span>Agregar Servicio</span></strong>
        <span v-if="isOpen && isTipoFacturaElectronicaEnLinea"
              style="color: red; font-size: 11px; margin-top: 5px; margin-left: 85px;">
          (Los productos bloqueados son porque no están relacionados con SIAT)
        </span>
      </div>
    </template>
      <div class="row mb-2">
        <div class="col-sm-6">
          <div class="form-group mb-0">
            <label class="col-form-label">Grupo de Servicio:</label>
            <multiselect v-model="categoriaServiciosSelected"
              :options="getCategoriaServicios"
              @input="actualizarListaServicios"
              placeholder=""
              label="nombre" track-by="id"
              select-label=""
              deselect-label="X">
              <span slot="caret" v-if="!(categoriaServiciosSelected===null)"></span>
              <span slot="noResult">Sin Resultados</span>
            </multiselect>
          </div>
        </div>
        <div class="col-sm-6" v-if="serviciosSelected.length < 2">
          <div class="form-group">
            <label class="col-form-label" style="user-select: none"><br></label>
            <div
              v-if=" listaPrecioSeguros.length !== 0"
              class="row mb-2"
            >
              <div class="col-sm-4 text-right pl-0">
                <label class="col-form-label">
                  Precio del Seguro:
                </label>
              </div>
              <div class="col-sm-4 px-0">
                <multiselect ref="comboPrecioSeguro"
                  id="comboPrecioSeguros"
                  v-model="precioSeguroSelected"
                  :options="listaPrecioSeguros"
                  @input="actualizarInputPrecioSeguro"
                  placeholder=""
                  label="nombre" track-by="id"
                  select-label=""
                  deselect-label="X">
                  <span slot="caret" v-if="!(precioSeguroSelected===null)"></span>
                  <span slot="noResult">Sin Resultados</span>
                  <span slot="noOptions">Lista Vacia</span>
                  <template slot="singleLabel" slot-scope="props">
                    <small>{{props.option.nombre}}</small>
                  </template>
                  <template slot="option" slot-scope="props">
                    <small>{{props.option.nombre}}</small>
                  </template>
                </multiselect>
              </div>
              <div class="col-sm-4">
                <input type="text"
                  class="form-control"
                  :value="inputPrecioSeguro | numeral('0,0.00')"
                  autocomplete="off"
                  disabled
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="col-form-label">Servicio:</label>
            <multiselect ref="comboServices"
              v-model="serviciosSelected"
              :options="listaServiciosInteligente"
              :multiple="true"
              :loading="loaderComboServicio"
              @input="handleInput"
              @open="handleOpen"
              @close="handleClose"
              @select="agregarItemListaTemporal"
              @remove="eliminarItemListaTemporal"
              placeholder=""
              label="nombre" track-by="id"
              select-label=""
              deselect-label="X">
                <span slot="caret" v-if="!(serviciosSelected.length===0)"></span>
                <span slot="noResult">Sin Resultados</span>
                <span slot="noOptions">Lista Vacia</span>
                <template slot="option" slot-scope="props">
                  <small v-if="props.option.is_insurer_service">
                    <b>* {{props.option.nombre}}</b>
                  </small>
                  <small v-else>
                    {{props.option.nombre}}
                  </small>
                </template>
            </multiselect>
          </div>
        </div>
        <div class="col-sm-6" v-if="serviciosSelected.length < 2">
          <div class="form-group">
            <label class="col-form-label" style="user-select: none"><br></label>
            <div class="row mb-2" v-if="getPrecios.length !== 0 && precioSeguroSelected === null">
              <div class="col-sm-4 text-right">
                <label class="col-form-label">
                  Lista de Precios:
                </label>
              </div>
              <div class="col-sm-4 px-0">
                <multiselect
                v-model="precioSelected"
                :options="getPrecios"
                @input="actualizarPrecioDelModal"
                :allow-empty="false"
                placeholder="Seleccionar"
                label="descuento" track-by="id"
                select-label=""
                deselect-label="X">
                <span slot="caret" v-if="!(precioSelected===null)"></span>
                <span slot="noResult">Sin Resultados</span>
                </multiselect>
              </div>
              <div class="col-sm-4">
                <input type="text"
                class="form-control"
                :value="precioModal| numeral('0,0.00')"
                autocomplete="off" disabled>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-sm-6">
          <div class="form-group">
            <label class="col-form-label" style="user-select: none"><br></label>
            <div class="row">
              <div class="col-sm-2 text-right">
                <label class="col-form-label"><b>Total:</b></label>
              </div>
              <div class="col-sm-3 px-0">
                <input type="text"
                class="form-control"
                :value="getSubTotalModal | numeral('0,0.00')"
                disabled>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <button class="btn btn-outline-dark" @click="cancel()">
          Cancelar
        </button>
        <button class="btn btn-warning" @click="ok()" :disabled="isDisabledAddButton">
          Agregar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

import { mapGetters, mapMutations, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { util } from '@/plugins/util';
import { MODALIDAD_FACTURACION } from '@/utils/globalConventions';
import { TheModalLaboratorio } from './TheModalLaboratorio.vue';

export default {
  name: 'AddServiceModal',
  components: {
    Multiselect,
    // eslint-disable-next-line vue/no-unused-components
    TheModalLaboratorio,
  },
  created() {
    this.getServiciosApi();
    this.$root.$on('pacienteSelected', (valor) => {
      this.pacienteSelected = valor;
    });
  },
  data() {
    return {
      isOpen: false,
      precioUModal: 0,
      loaderComboServicio: false,
      modalShow: false,
      pacienteSelected: null,
      servicioSinFiltro: [],
      listaAsegurado: [],
    };
  },
  methods: {
    handleOpen() {
      this.isOpen = true;
    },
    handleClose() {
      this.isOpen = false;
    },
    openModalServicios() {
      if (this.disableButtonAddServicio) {
        return;
      }
      if (this.checkSeguroEstado && this.aseguradoraSelected === null) {
        util.showNotify('Elija un Seguro Medico.', 'warn');
        return;
      }
      this.$bvModal.show('modal-servicios');
    },
    openModalLaboratorio() {
      if (this.cierreConfirmado) {
        return;
      }
      this.$bvModal.show(`modal-laboratorio-${'0-lab'}`);
    },
    handleInput(value) {
      if (this.aseguradoraSelected !== null) {
        // Si viene como array, tomo el último elemento
        const item = Array.isArray(value) ? value[value.length - 1] : value;
        this.listaAsegurado.push(item);
      }
    },
    actualizarListaServicios() {
      this.setServicios([]);
      this.setPrecios([]);
      this.listaPrecioSeguros = [];
      if (this.categoriaServiciosSelected !== null) {
        this.getServiciosApi();
      } else {
        this.serviciosSelected = [];
        this.setListaTemporal([]);
        this.setListaDetalleTemporal([]);
      }
    },
    async agregarItemListaTemporal(el) {
      /*  if (this.serviciosSelected.length === 1 && this.aseguradoraSelected !== null) {
        await this.eliminarItemListaTemporal(this.serviciosSelected[0]);
      } */

      this.loaderComboServicio = true;
      this.setItemListaTemporal(el);
      await this.getPreciosServicio();

      if (this.listaPrecioSeguros.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        this.precioSeguroSelected = this.listaPrecioSeguros[0];
      } else {
        this.precioSeguroSelected = this.listaPrecioSeguros[0] ? this.listaPrecioSeguros[0] : null;
      }
      this.actualizarInputPrecioSeguro();

      if (this.getListaTemporal.length < 2) {
        await this.getServiciosApi();
      }

      this.loaderComboServicio = false;
      /* if (this.modalShow) {
        if (this.seguroDobleSelected) {
          this.actualizarInputPrecioSeguro();
        }
      } */
    },
    eliminarItemListaTemporal(el) {
      // quita de las listas temporales del store
      this.deleteItemListaTemporal(el.id);
      this.deleteItemListaDetalleTemporal(el.id);

      if (this.aseguradoraSelected !== null && Array.isArray(this.listaAsegurado)) {
        this.listaAsegurado = this.listaAsegurado.filter((s) => s.id !== el.id);
      }

      if (this.getListaTemporal.length === 0) {
        this.setPrecios([]);
        this.listaPrecioSeguros = [];
        if (this.getListaTabla.length === 0) {
          this.setActividadEconomicaId(0);
          this.setDocumentoSectorId(null);
          this.setSiatTipoFacturaId(null);
          this.getServiciosApi();
        }
      }
      if (this.getListaTemporal.length === 1) {
        this.deleteLastListaDetalleTemporal();
        this.getPreciosServicio();
      }
      this.$refs.comboServices.$el.focus();
    },
    precioUnitario() {
      if (this.precioSeguroSelected !== null) {
        return parseFloat(this.inputPrecioSeguro).toFixed(2);
      }
      return parseFloat(this.precioModal).toFixed(2);
    },
    precioTotal() {
      if (this.precioSeguroSelected !== null) {
        return this.cantidad * (
          parseFloat(this.inputPrecioSeguro) + parseFloat(this.precioSeguroSelected.seguro)
        );
      }
      return this.cantidad * parseFloat(this.precioModal);
    },
    actualizarInterfaz() {
      this.actualizarTotalSeguro();
      this.actualizarTotalSeguroDoble();
      this.actualizarSubTotal();
      this.getServiciosApi();
      this.setRegistroQr(null);
      if (this.getModoEdicion === false) {
        if (this.getCheckFacturaTercero === false) {
          // si la modalidad es preVENTA NO agregar por defecto y bloquar ajuste y alcontado
          if (this.getTipoFactura !== MODALIDAD_FACTURACION.PREVENTA) {
            this.agregarMedioPagoContadoPorDefecto();
            this.setInsigniasFormaPagoContadoDefault();
          }
        } else {
          this.setClassButton('btn-success');
          this.setInsigniasFormaPagoFacturacionTercero();
        }
      }
      this.monto1 = this.getTotalVenta;
      if (this.nroCajas > 1) {
        // this.setClassButton('btn-danger');
        // this.nroCajas = 1;
        // this.modalComboSelected2 = null;
        // this.modalComboSelected3 = null;
        // this.monto2 = 0;
        // this.monto3 = 0;
        this.clearFormaPagoCajas();
        this.resetAjustesModal();
        this.listaBadges = [];
      }
    },
    agregarServicio(bvModalEvt) {
      if (this.getServiciosSelected.length === 0) {
        util.showNotify('Elije un Servicio', 'warn');
        bvModalEvt.preventDefault();
        return;
      }
      if (this.cantidad <= 0) {
        util.showNotify('Ingrese un Cantidad Mayor a 0!', 'warn');
        bvModalEvt.preventDefault();
        return;
      }
      this.precioModal = this.precioModal.toString().trim();
      if (this.precioModal === '') {
        util.showNotify('Precio no Valido', 'warn');
        return;
      }
      if (this.seguroDobleSelected) {
        if (!this.precioSeguroSelected) {
          util.showNotify('Debe seleccionar el precio del seguro', 'warn');
          bvModalEvt.preventDefault();
          return;
        }
      }
      /*  if (this.checkValorCero && parseInt(this.precioUnitario(), 10) !== 0) {
        util.showNotify('El CoaSeguro debe ser igual a 0', 'warn');
        return;
      } */
      // if (this.getListaDetalleTemporal.length === 1) {
      const segurosMap = new Map(
        (this.serviciosSelected || []).map((s) => [s.id, s.seguro]), // s.id debe ser el id del servicio
      );
      const precioMap = new Map(
        (this.serviciosSelected || []).map((s) => [s.id, s.inputPrecioSeguro]), // s.id debe ser el id del servicio
      );
      this.getListaDetalleTemporal.forEach((servicioTemporal) => {
        /*
            para modificar item tambien modificar el itemServicio en addServiceModal.js en la funcion getPreciosServicio,
            ya que los 2 objetos estan relacionados. es decir si agrego alguna propiedad o quito tambien hacerlo en los 2 lados.

          // lo mismo para modalReserva y modalCotizacion, modalInternacion
        */
        let siatActividadEconomicaId = servicioTemporal.siat_actividad_economica_id;
        let siatDescripcionService = servicioTemporal.siat_descripcion_service;
        let siatDescripcionUnidadMedida = servicioTemporal.siat_descripcion_unidad_medida;
        let siatTipoProductoServiceId = servicioTemporal.siat_tipo_producto_service_id;
        let siatUnidadMedidaId = servicioTemporal.siat_unidad_medida_id;
        const medico = this.getMedicoSelected;
        if (medico) {
          if (medico.configuracion_factura_tercero === 0) {
            siatActividadEconomicaId = medico.siat_actividad_economica_id;
            siatDescripcionService = medico.siat_nombre_producto_servicio;
            siatDescripcionUnidadMedida = medico.siat_nombre_unidad_medida;
            siatTipoProductoServiceId = medico.siat_producto_servicio_id;
            siatUnidadMedidaId = medico.siat_unidad_medida_id;
          }
        }
        // se puso en un array auxiliar y luego se compara y pone el seguro
        const seguroPorServicio = segurosMap.get(servicioTemporal.servicio_id) ?? servicioTemporal.seguro;
        const precioUnitario = precioMap.get(servicioTemporal.servicio_id) ?? servicioTemporal.inputPrecioSeguro;
        // eslint-disable-next-line no-nested-ternary

        const precioUnitarioFinal = precioUnitario ?? servicioTemporal.precio_unitario;
        let total = 0;
        total = servicioTemporal.cantidad * (
          parseFloat(precioUnitarioFinal) + parseFloat(seguroPorServicio)
        );
        const item = {
          numero: servicioTemporal.numero,
          servicio_id: servicioTemporal.servicio_id,
          descripcion: servicioTemporal.descripcion,
          medicoTempSelected: null,
          cantidad: this.cantidad,
          precio_unitario: precioUnitarioFinal,
          total,
          servicio: servicioTemporal.servicio,
          /* desc: '-', */
          seguro: seguroPorServicio,
          fecha_turno: null,
          hora_turno: null,
          numero_ticket: null,
          numero_turno: null,
          turno_medico_id: null,
          is_turno_manual: servicioTemporal.is_turno_manual,
          siat_actividad_economica_id: siatActividadEconomicaId,
          siat_descripcion_service: siatDescripcionService,
          siat_descripcion_unidad_medida: siatDescripcionUnidadMedida,
          siat_tipo_producto_service_id: siatTipoProductoServiceId,
          siat_unidad_medida_id: siatUnidadMedidaId,
          idRow: servicioTemporal.idRow,
          tipo_atencion_id: null,
          medicoDerivadorSelected: null,
          por_enfermeria: false,
          descuento: 0,
          insumo_id: servicioTemporal.insumo_id,
          insumo_orden_trabajo_id: servicioTemporal.insumo_orden_trabajo_id
            ? servicioTemporal.insumo_orden_trabajo_id : null,
          active_hc: servicioTemporal.active_hc ? servicioTemporal.active_hc : false,
          is_orden_trabajo: false,
          orden_trabajo_medicos_id: [],
          tipo_id: null,
        };
        this.addItemlistaTabla(item);
      });
      // } else {
      /* this.getListaDetalleTemporal.forEach((servicioTemp) => {
            this.addItemlistaTabla(servicioTemp);
          });
        } */
      this.setListaTemporal([]);
      this.setListaDetalleTemporal([]);
      this.actualizarInterfaz();
      this.resetearModal();
      bvModalEvt.preventDefault();
    },
    resetearModal() {
      this.listaAsegurado = [];
      this.resetModalWhenClosed();
      this.precioUModal = 0;
      this.inputPrecioSeguro = 0;
    },
    actualizarPrecioInput() {
      this.precioModal = this.precioSelected.monto;
    },
    actualizarPrecioDelModal() {
      this.actualizarPrecioInput();
      this.precioUModal = 0;
    },
    actualizarPrecioModal() {
      if (this.precioUModal === '') {
        this.getPreciosServicio();
      } else {
        this.precioSelected = null;
        this.precioModal = this.precioUModal;
      }
    },
    validarCaracter(event) {
      const validKeys = new RegExp('^[0-9]*$');
      const controlKeys = ['Delete', 'Backspace', 'ArrowLeft', 'ArrowRight', 'KeyX', 'KeyC', 'KeyV', 'Home', 'End', 'Tab'];
      if (controlKeys.includes(event.code)) {
        switch (event.code) {
          case 'KeyX':
            if (!event.ctrlKey) {
              event.preventDefault();
            }
            break;
          case 'KeyC':
            if (!event.ctrlKey) {
              event.preventDefault();
            }
            break;
          case 'KeyV':
            if (!event.ctrlKey) {
              event.preventDefault();
            }
            break;
          default:
            break;
        }
        return;
      }
      if (!validKeys.test(event.key)) {
        event.preventDefault();
      }
    },
    reValidarCantidad() {
      if (this.cantidad === '') {
        return;
      }
      const validKeys = new RegExp('^[0-9]*$');
      if (!validKeys.test(this.cantidad)) {
        this.cantidad = '';
      }
    },
    actualizarInputPrecioSeguro() {
      if (this.precioSeguroSelected !== null) {
        this.inputPrecioSeguro = this.precioSeguroSelected.monto;
      } else {
        this.inputPrecioSeguro = 0;
      }
    },
    ...mapMutations('addServiceModal', [
      'setActividadEconomicaId',
      'setDocumentoSectorId',
      'setSiatTipoFacturaId',
      'setServicios',
      'setListaTemporal',
      'setListaDetalleTemporal',
      'setItemListaTemporal',
      'deleteItemListaTemporal',
      'deleteItemListaDetalleTemporal',
      'deleteLastListaDetalleTemporal',
      'setPrecios',
    ]),
    ...mapMutations('tableAndAddService', [
      'addItemlistaTabla',
    ]),
    ...mapMutations('formaPagoModal', [
      'agregarMedioPagoContadoPorDefecto',
      'setClassButton',
      'setRegistroQr',
    ]),
    ...mapActions('formaPagoModal', [
      'resetDatosFormaPagoModal',
      'resetAjustesModal',
      'clearFormaPagoCajas',
    ]),
    ...mapActions('detalleFactura', [
      'setInsigniasFormaPagoContadoDefault',
      'setInsigniasFormaPagoFacturacionTercero',
    ]),
    ...mapActions('addServiceModal', [
      'getServiciosApi',
      'getPreciosServicio',
      'resetModalWhenClosed',
    ]),
    ...mapActions('detalleFactura', [
      'actualizarSubTotal',
      'actualizarTotalSeguro',
      'actualizarTotalSeguroDoble',
    ]),
  },
  computed: {
    ...mapFields('addServiceModal', [
      'categoriaServiciosSelected',
      'serviciosSelected',
      'precioSelected',
      'precioModal',
      'cantidad',
      'isDisabledAddButton',
      'precioSeguroSelected',
      'listaPrecioSeguros',
      'inputPrecioSeguro',
    ]),
    ...mapFields('formFactura', [
      'checkSeguroEstado',
      'aseguradoraSelected',
      'checkValorCero',
    ]),
    ...mapFields('modalCierreTratamiento', [
      'cierreConfirmado',
    ]),
    ...mapFields('formaPagoModal', [
      'nroCajas',
      'modalComboSelected2',
      'modalComboSelected3',
      'monto2',
      'monto3',
      'monto1',
    ]),
    ...mapFields('detalleFactura', [
      'listaBadges',
      'seguroDobleSelected',
    ]),
    ...mapFields('facturacion', [
      'hasEnabledLaboratory',
    ]),
    listaServiciosInteligente() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (this.isTipoFacturaElectronicaEnLinea) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.servicioSinFiltro = this.getServicios.map((element) => {
          if (!element.siat_tipo_producto_service_id) {
          // eslint-disable-next-line no-param-reassign
            element.$isDisabled = true;
          } else {
          // eslint-disable-next-line no-param-reassign
            element.$isDisabled = false;
          }
          return element;
        });
      }
      return this.getServicios;
    },
    ...mapGetters('main', [
      'isBloqueadoPrecioVenta',
    ]),
    ...mapGetters('facturacion', [
      'getModoEdicion',
    ]),
    ...mapGetters('formFactura', [
      'getMedicoSelected',
      'getMedicos',
      'getCheckFacturaTercero',
      'getTipoFactura',
      'isTipoFacturaSinFactura',
      'isTipoFacturaConFactura',
      'isTipoFacturaComputarizada',
      'isTipoFacturaManual',
      'isTipoFacturaComputarizadaEnLinea',
      'isTipoFacturaElectronicaEnLinea',
    ]),
    ...mapGetters('tableAndAddService', [
      'getListaTabla',
    ]),
    ...mapGetters('addServiceModal', [
      'getCategoriaServicios',
      'getServiciosSelected',
      'getServicios',
      'getListaTemporal',
      'getListaDetalleTemporal',
      'getPrecios',
      'getSubTotalModal',
    ]),
    ...mapFields('modalReserva', [
      'reservaId',
    ]),
    disableButtonAddServicio() {
      let disabled = false;
      if (this.cierreConfirmado) {
        disabled = true;
      }
      if (this.reservaId) {
        disabled = true;
      }
      return disabled;
    },
    ...mapGetters('detalleFactura', [
      'getTotalVenta',
    ]),
  },
  watch: {
    precioSeguroSelected(val) {
      if (this.listaAsegurado.length > 0) {
        const idx = this.listaAsegurado.length - 1;
        this.actualizarInputPrecioSeguro();
        this.listaAsegurado[idx].seguro = val?.seguro ?? '0.00';
        this.listaAsegurado[idx].inputPrecioSeguro = this.precioUnitario();
      }
    },
    // 🔒 mantener listaAsegurado consistente con lo seleccionado
    serviciosSelected(nuevos) {
      const ids = new Set((nuevos ?? [])
        .map((s) => s?.id)
        .filter(Boolean)); // solo ids válidos

      // si no hay seleccionados, limpia y sal
      if (ids.size === 0) {
        this.listaAsegurado = [];
        return;
      }

      this.listaAsegurado = (this.listaAsegurado ?? [])
        .filter((s) => s?.id && ids.has(s.id));
    },
  },
};
</script>

<style scoped>
.text-skyblue
{
  color: #61c6f2;
}
a.text-skyblue:hover{
  color:#1565c0;
}
.btn-custom {
  padding: 10px 15px;
  word-break: break-word;
  display: inline-block;
  word-wrap: break-word;
  text-align: center;
}

.btn-block {
  width: 100%;
}

@media (max-width: 1226px) {
  .btn-custom {
    font-size: 10px;
    padding: 8px;
  }
}
.disabled-plomo {
  background-color: #b1a9a9; /* Color plomo (gris claro) */
  pointer-events: none; /* Desactiva la interacción */
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
